import { Campaign } from '../campaign/campaign';

export class TestCase {
    name: string = null;
    listId: string;
    subjects: string[];
    bodies: string[];
    deliveryServers: number[];
    trackingDomains: number[];
    useDeliveryServerTrackingDomain: boolean;
    campaigns: Campaign[] = [];

    static parseJson(json: any): TestCase {
        if (json === null || json === undefined) { 
            return null;
        }

        return Object.assign(new TestCase(), json);
    }
}
